var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityandPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71338 8.21374C7.71338 8.9527 8.00693 9.66139 8.52945 10.1839C9.05198 10.7064 9.76067 11 10.4996 11C11.2386 11 11.9473 10.7064 12.4698 10.1839C12.9923 9.66139 13.2859 8.9527 13.2859 8.21374C13.2859 7.47478 12.9923 6.76609 12.4698 6.24356C11.9473 5.72104 11.2386 5.42749 10.4996 5.42749C9.76067 5.42749 9.05198 5.72104 8.52945 6.24356C8.00693 6.76609 7.71338 7.47478 7.71338 8.21374Z",
    stroke: "black",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.3587C12.6638 18.6375 14.5223 17.3511 15.9336 15.6965C14.657 14.1071 12.6973 13.0897 10.5 13.0897C8.30272 13.0897 6.34307 14.1071 5.06641 15.6965C6.47771 17.3511 8.33621 18.6375 10.5 19.3587Z",
    stroke: "black",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4655 2.64124H3.53424C2.76484 2.64124 2.14111 3.26497 2.14111 4.03436V7.76158C2.14111 13.0234 5.5081 17.6948 10.4999 19.3587C15.4916 17.6948 18.8586 13.0234 18.8586 7.76158V4.03436C18.8586 3.26497 18.2349 2.64124 17.4655 2.64124Z",
    stroke: "black",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityandPrivacy);
export default __webpack_public_path__ + "static/media/SecurityandPrivacy.da83b8bf2e07a4bf41f33780ce4ae6d3.svg";
export { ForwardRef as ReactComponent };